import React from 'react';
import styles from './TopNotification.module.scss';

export type TopNotificationProps = {
  /** Invoked when the user dismisses the notification via the close control. */
  onClose: () => void;
  /** Body content. The shell owns only the chrome; callers own what is inside. */
  children: React.ReactNode;
  /** Optional extra class on the card, for caller-specific styling. */
  className?: string;
};

/**
 * Thin, reusable top-centre notification shell.
 *
 * It is a non-blocking overlay (no backdrop), fixed at the top centre of the
 * viewport, and it never auto-dismisses — the user closes it with the cross.
 * Visibility is owned by the caller: mount it to show, unmount to hide. The
 * shell renders only the frame and the close control; all content comes in as
 * children, which keeps it open for extension without changing the shell.
 */
export function TopNotification({ onClose, children, className }: TopNotificationProps) {
  return (
    <div className={styles.wrapper} role="status" aria-live="polite">
      <div className={className ? `${styles.card} ${className}` : styles.card}>
        <button
          type="button"
          className={styles.close}
          aria-label="Close"
          onClick={onClose}
        >
          ×
        </button>
        <div className={styles.body}>{children}</div>
      </div>
    </div>
  );
}
